import React from 'react'
import { Box } from '@ally/metronome-ui'
import { LoadState } from '@ally/use-data-domain'

import WidgetError from '../WidgetError'
import LoadingSpinner from '../LoadingSpinner'

import { BirthdayBadge } from './badges/Birthday'
import { LoyaltyBadge } from './badges/Loyalty'
import { PreferredBrowserBadge } from './badges/PreferredBrowser'

import { useHostServices } from '../../../HostServices'

const WidgetBody: React.FC = (): React.ReactElement => {
  const { hostData } = useHostServices()

  const legacyCustomer = hostData?.customer?.data
  const afgCustomer = hostData?.afgCustomer?.data

  const loadingState =
    hostData?.customer?.status?.loadState ??
    hostData?.afgCustomer?.status?.loadState

  switch (loadingState) {
    case LoadState.LOADED:
      return (
        <Box
          mt="-8px"
          mx="-8px"
          pt="sm"
          px="xs"
          data-testid="badge-widget-content"
        >
          <BirthdayBadge
            legacyCustomer={legacyCustomer}
            afgCustomer={afgCustomer}
          />
          <LoyaltyBadge
            legacyCustomer={legacyCustomer}
            afgCustomer={afgCustomer}
          />
          <PreferredBrowserBadge />
        </Box>
      )

    case LoadState.FAILED:
      return <WidgetError />

    case LoadState.LOADING:
      return <LoadingSpinner />

    default:
      return <WidgetError />
  }
}

export default WidgetBody
